import React, { useContext } from "react";
import "../../../css/home/home.css"; // Asegúrate de crear este archivo CSS también
import { GLOBAL_LANGUAGE } from "../../../language/language";
import { UtilContext } from "../../../context/UtilContext"; // Asegúrate de importar el contexto correcto
import ButtonWhite from "../../button/ButtonWhite";


const Welcome = ({ name, onClick }) => {
  const { language } = useContext(UtilContext); // Usa el contexto de Auth


  return (
    <div className="w-full">
      <p className="text-2xl md:text-3xl mt-6 md:mt-8" style={{ fontFamily: "brico" }}>
        {GLOBAL_LANGUAGE[language].welcome.saludo +
          `${name}` +
          GLOBAL_LANGUAGE[language].welcome.title}
      </p>
      <p className="text-[#E4E4E4] text-[14px] mt-2 mb-6 md:mb-8">
        {GLOBAL_LANGUAGE[language].welcome.subtitle}
      </p>

      <div className="flex flex-row justify-between mt-4">
        <ButtonWhite
          onClick={onClick}
          label={GLOBAL_LANGUAGE[language].welcome.label_button}
          className="w-full md:w-fit"
        />
      </div>
    </div>
  );
};

export default Welcome;
